import React from "react";
import EICPublicForm from "./EICPublicForm";

const EICPublicFormWrapper: React.FC = () => {
  return <EICPublicForm />;
};

export default EICPublicFormWrapper;
